import {BaseMuWidget} from "./BaseMuWidget";
import {TicketsCL} from "./generated/TicketsCL";
import {Arrays} from "./Utils";
import {MuNamedWidgets} from "mu-widget/lib/MuWidget";
import {MultiUpload} from "./MultiUpload";
import {InvoiceApproval} from "./InvoiceApproval";

export class UiAttaches extends BaseMuWidget
{
	public upladEnabled: boolean = false;

	public ticketId: number|null = null;

	public cl: TicketsCL = new TicketsCL();

	public uploadUrl: string = "/ticket/upload-raw-attach";

	public label: string = "Přílohy";

	// @ts-ignore
	private attachesById: Record<number, any>;

	// @ts-ignore
	muNamedWidget: MuNamedWidgets<{
		mupNewAttach: MultiUpload
	}>;

	beforeIndex() {
		this.container.classList.add('attaches');
		this.muAppendContent(`
			<!-- div mu-id="pAttaches" class="" -->
				<strong mu-id="label">Přílohy</strong>
				<strong><span mu-id="pPreviewLabel">Náhled</span></strong>
				<div class="grid-row-s2 attaches__list" mu-id="pAttachesList">
					<ul mu-id="attachList" mu-bind="attachList:@foreach">
						<li mu-widget="InvoiceCreatorAttachesListItem" mu-template="attachListItem"
							mu-bind="id:.id;contentType:.contentType" class="invoice-approval--attach">
							<span class="invoice-approval--attache-item a icon-before-document-file" mu-id="name" mu-bind="fileName;fileName:@attr.title"></span>
						</li>
					</ul>
					<div class="text-center checkbox" mu-id="pShowJunk">
						<label class="" title="Zobrazit přílohy které pravděpodobně neobsahují fakturu"><input mu-id="showAttachJunk" type="checkbox" />
							zobrazit vše (<span mu-id="fullCount"></span>)
						</label>
					</div>
				</div>
				<div class="attaches__preview">
					<div mu-id="preview"></div>
				</div>
				<div class="buttons" mu-id="previewButtons">
					<a target="_blank" class="btn-icon btn-icon-size-5 icon-before-download" mu-id="bDownload">Stáhnout</a>
					<span class="btn-icon btn-icon-size-5 icon-before-close" mu-id="bClosePreview">Zavřít náhled</span>
				</div>
			<!-- /div -->` + (
				this.upladEnabled
					? `<div class="grid-column-s2 display-flex-row">
						<div mu-id="mupNewAttach" mu-widget="MultiUpload" class="flex-grow-1"></div>
						<div class="buttons flex-grow-0" mu-id="pUploadButton"><span class="btn-icon btn-icon-size-5 icon-before-up" mu-id="bUploadButton">Uložit vybrané přílohy</span></div>
					</div>`
					: ''
			) + ``
		);
	}

	afterIndex() {
		this.ui.label.innerText = this.label;
		this.mupNewAttach_change();
		this.bClosePreview_click();
		if (this.ticketId) this.loadAttaches();
	}

	mupNewAttach_change() {
		if (this.muNamedWidget.mupNewAttach)
			this.muVisible(this.muNamedWidget.mupNewAttach.getAllFiles().length > 0, "pUploadButton");
	}

	async bUploadButton_click() {
		var res = await this.muNamedWidget.mupNewAttach.sendToBackend((ctx, send) => {
			ctx.url = this.uploadUrl + "?metadata=" + encodeURIComponent(JSON.stringify({
				ticketId: this.ticketId,
				fileName: ctx.file.name,
				contentType: ctx.file.type,
				size: ctx.file.size,
			}));
			send();
		});
		this.loadAttaches();
		this.muNamedWidget.mupNewAttach.clear();
	}

	public loadAttaches() {
		// @ts-ignore
		this.cl.getAttachesFotTicketAndRelated(this.ticketId).then(
			data => {
				this.muBindData({attachList: data/*.filter(a => a.fileName)*/ });
				this.muVisible(!!data.length || this.upladEnabled, '.');
				this.muVisible(!!this.container.querySelector(".invoice-approval--attach__is-junk"), 'pShowJunk');
				this.ui.fullCount.innerText = data.length;
				this.attachesById = Arrays.ToObject(data,'id');
			}
		);
	}

	showAttach(id: number) {
		(this.ui.bDownload as unknown as HTMLAnchorElement).href = this.attachesById[id].dowloadLink;
		this.cl.getAttachDetail(id, this.ticketId).then(
			data => {
				this.ui.preview.innerHTML = data;
				this.muVisible(true, ['preview', 'previewButtons', 'pPreviewLabel']);
				// @ts-ignore
			}
		);
	}

	bClosePreview_click() {
		this.ui.preview.innerHTML = '';
		this.muVisible(false, ['preview', 'previewButtons', 'pPreviewLabel']);
	}

	showAttachJunk_change(ev: Event) {
		ev.cancelBubble = true;
		ev.stopPropagation();
		this.container.classList.toggle(
			'attaches__show-is-junk',
			this.ui.showAttachJunk.checked
		)
	}

}

export class InvoiceCreatorAttachesListItem extends BaseMuWidget {

	// @ts-ignore
	muParent : UiAttaches;

	// @ts-ignore
	id: number;
	private isJunk: boolean = false;

	name_click() {
		this.muParent.showAttach(this.id);
	}

	protected muAfterBindData(data: any) {
		let isJunk = true;
		const contentType = data.contentType.toLowerCase();
		if (!data.inTextImage) {
			if ([
				'application/msword',
				'application/pdf',
				'application/vnd.ms-excel',
				'application/vnd.ms-office',
				'application/vnd.oasis.opendocument.spreadsheet',
				'application/vnd.oasis.opendocument.text',
				'application/vnd.openxmlformats-officedocument.presentationml.presentation',
				'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
				'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
			].includes(contentType)) {
				isJunk = false;
			} else {
				isJunk = !contentType.startsWith('image/') || data.fileSize < 14*1024;
			}
		}

		this.container.classList.toggle('invoice-approval--attach__is-junk', isJunk);
		this.isJunk = isJunk;
	}
}